import { Card, CardBody, CardHeader, Image } from "@nextui-org/react";
import React from "react";
import feedbackCardImg from "../../Assets/landing/feedbackCardImg.svg";
import feedbackCardImg3 from "../../Assets/landing/feedbackCardImg3.jpg";
import feedbackCardImg2 from "../../Assets/landing/feedbackCardImg2.jpg";

const Feedback = () => {
  return (
    <section className="feedbak py-12">
      <div className="container xl:px-20 px-6 mx-auto">
        <h2 className="bg-clip-text text-transparent bg-mainGradiant text-38px font-bold text-center mb-12">
          Users Feedback
        </h2>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-9">
          <Card className="p-10 rounded-20px border-2 border-solid border-cardColor shadow-cardNonActiveShadow transition-all duration-250 hover:scale-105 hover:shadow-cardActiveShadow has-focus">
            <CardHeader className="flex gap-4 p-0 mb-6">
              <Image
                alt="Feedback"
                src={feedbackCardImg}
                className="w-[73px] h-[73px] rounded-full"
              />
              <div className="flex flex-col gap-2">
                <h4 className="text-2xl font-bold">Caroline Purton</h4>
                <p className="text-lg text-cardGrayColor">Wedding Planner</p>
              </div>
            </CardHeader>
            <CardBody className="p-0">
              <p className="text-2xl opacity-75 leading-[33.6px]">
                “This app is amazing, I’m generally not a very organised person. Which can be stressful. This app has helped me plan projects , organise tasks, events , and even holidays.
                 Its made my life so much easier. Definitely worth downloading! Excellent idea! “
              </p>
            </CardBody>
          </Card>
          <Card className="p-10 rounded-20px border-2 border-solid border-cardColor shadow-cardNonActiveShadow transition-all duration-250 hover:scale-105 hover:shadow-cardActiveShadow focus:border-cardColor has-focus">
            <CardHeader className="flex gap-4 p-0 mb-6">
              <Image
                alt="Feedback"
                src={feedbackCardImg2}
                className="w-[73px] h-[73px] rounded-full"
              />
              <div className="flex flex-col gap-2">
                <h4 className="text-2xl font-bold">Henry William</h4>
                <p className="text-lg text-cardGrayColor">Camera Operator</p>
              </div>
            </CardHeader>
            <CardBody className="p-0">
              <p className="text-2xl opacity-75 leading-[33.6px]">
                “ This app was very helpful and kept me organised with all
                 my plans and I highly recommend this app to get yourself more 
                organised and make your life a bit easier. Make sure you download it😄 “
              </p>
            </CardBody>
          </Card>
          <Card className="lg:col-span-1 md:col-span-2 col-span-1 p-10 rounded-20px border-2 border-solid border-cardColor shadow-cardNonActiveShadow transition-all duration-250 hover:scale-105 hover:shadow-cardActiveShadow has-focus">
            <CardHeader className="flex gap-4 p-0 mb-6">
              <Image
                alt="Feedback"
                src={feedbackCardImg3}
                className="w-[73px] h-[73px] rounded-full"
              />
              <div className="flex flex-col gap-2">
                <h4 className="text-2xl font-bold">Robert Andrew</h4>
                <p className="text-lg text-cardGrayColor">IT Support Specialist</p>
              </div>
            </CardHeader>
            <CardBody className="p-0">
              <p className="text-2xl opacity-75 leading-[33.6px]">
                “ I have been using the app for a few weeks now and am really enjoying it.
                 Great UI, the app is easy to use and is helping me keep track of all the things I am doing with the family and organising my personal projects.
                 Would highly recommend and look forward to the next updates. Great idea! “
              </p>
            </CardBody>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Feedback;
